var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, observable, makeObservable } from 'mobx';
import { runtime } from '../../runtime/Runtime';
export class StageDraftLayout {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get stage() {
        return this.parent;
    }
    get app() {
        return this.stage.app;
    }
    get totalMenuHeightsInPixel() {
        let h = 0;
        if (runtime.isBrowserRuntime && !runtime.solidBrowserRuntime.browserFullscreen.isInFullscreen && !this.app.appInfo.isMobileAppWebView) {
            h += 45; // Menubar
        }
        if (this.app.menubar.menubarRight.isMultiPlayerMode) {
            h += 120;
        }
        return h;
    }
    get outerHeightInCss() {
        if (runtime.browserRuntime && runtime.browserRuntime.browserAgent.isSafari) {
            return `calc(var(--app-height) - ${this.totalMenuHeightsInPixel}px)`;
        }
        return `calc(100vh - ${this.totalMenuHeightsInPixel}px)`;
    }
    get outerHeightInPixel() {
        return this.stage.app.appMeasure.appHeightInPixel - this.totalMenuHeightsInPixel;
    }
    get availableWidth() {
        if (runtime.isBot)
            return runtime.runtimeBot.botStageWidthHeight; // 340
        let availableWidth = this.stage.app.appMeasure.appWidthInPixel;
        if (this.app.appInfo.isUserCurrentlyEditing)
            availableWidth -= 500; // edit side bars
        return availableWidth;
    }
    manualStageWidthHeight;
    get availableHeight() {
        if (runtime.isBot)
            return runtime.runtimeBot.botStageWidthHeight; // 340
        let h = this.outerHeightInPixel;
        if (this.shouldShowBottomAd) {
            h -= 90; // Ad height
        }
        if (!this.app.appInfo.isMobileAppWebView) {
            h -= 45; // CycleBar
        }
        return h;
    }
    get shouldShowBottomAd() {
        if (this.app.appInfo.isPremiumApp)
            return false;
        if (this.stage.app.appInfo.isMobileAppWebView)
            return false;
        if (runtime.isServerRuntime)
            return false;
        if (runtime.solidBrowserRuntime.browserDevice.isSmallHeightDevice)
            return false;
        if (runtime.solidBrowserRuntime.browserDevice.isSmallWidthDevice)
            return false;
        if (this.app.pathURI.includes('vorschule'))
            return false;
        return true;
    }
    get aspectRatio() {
        return this.stage.inner.valueOf.aspectRatio;
    }
    get isWidthBased() {
        return this.availableWidth / this.aspectRatio < this.availableHeight;
    }
    get width() {
        if (this.isWidthBased) {
            return this.availableWidth;
        }
        return Math.floor(this.availableHeight * this.aspectRatio);
    }
    get height() {
        if (this.isWidthBased) {
            return Math.floor(this.availableWidth / this.aspectRatio);
        }
        return this.availableHeight;
    }
    get rightOfInnerWidth() {
        return (this.availableWidth - this.width) / 2;
    }
    get stageUnitInPixel() {
        return this.width / 1000;
    }
}
__decorate([
    computed
], StageDraftLayout.prototype, "totalMenuHeightsInPixel", null);
__decorate([
    observable
], StageDraftLayout.prototype, "manualStageWidthHeight", void 0);
__decorate([
    computed
], StageDraftLayout.prototype, "width", null);
__decorate([
    computed
], StageDraftLayout.prototype, "height", null);
